import { colors } from 'style/colors';

export const getCompanyColor = () => colors.hrx.blue;
